
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProcessSection from './components/ProcessSection';
import DigitalUpgradesSection from './components/DigitalUpgradesSection';
import PricingSection from './components/PricingSection';
import MerchandiseSection from './components/MerchandiseSection';
import ContactSection from './components/ContactSection';
import VideoGallerySection from './components/VideoGallerySection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-primary-black">
      <Navbar />
      <HeroSection />
      <ProcessSection />
      <PricingSection />
      <DigitalUpgradesSection />
      <VideoGallerySection />
      <MerchandiseSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
